
import React from "react";
import Web3 from "web3";
import { Router } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "./theme/Theme";
import "./App.css";
import MainApp from "./mainApp";
import CiiesAbi from './util/contract/CitiesAbi.json'
import Envirnment from "./util/environment";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import history from './history/history'
import axios from "axios";
const web3 = new Web3(Web3.givenProvider || "ws://localhost:8545");

function App() {

  const [Useraccount, setAccount] = React.useState('')
  const [mincontract, setMintContract] = React.useState()



  const connectTotheWallet = () => {
    Ethereum();
    async function Ethereum() {
      window.ethereum && window.ethereum.enable();
      if (typeof window.ethereum !== "undefined") {
        let connectAccount = setInterval(async () => {
          const account = await window.ethereum.request({
            method: "eth_requestAccounts",
          });
          if (account) {
            setAccount(account[0])

            const Contract = new web3.eth.Contract(
              CiiesAbi,
              Envirnment.contractAddress
            );
            setMintContract(Contract)
          }
          clearInterval(connectAccount);
        }, 500);
      }
    }
  }


  React.useEffect(() => {
    Ethereum();
    async function Ethereum() {
      if (typeof window.ethereum !== "undefined") {
        let connectAccount = setInterval(async () => {
          const account = await web3.eth.getAccounts()
          if (account) {
            setAccount(account[0])
            const Contract = new web3.eth.Contract(
              CiiesAbi,
              Envirnment.contractAddress
            );
            setMintContract(Contract)
          }
          clearInterval(connectAccount);
        }, 500);
      }
    }
  }, [])

  let final
  const Init = async () => {
    try {
      Ethereum();
      async function Ethereum() {
        window.ethereum.on("accountsChanged", (accounts) => {
          final = Web3.utils.toChecksumAddress(accounts[0]);
          setAccount(final)
        });
      }
    } catch (err) {

    }
  }

  React.useLayoutEffect(() => {

    Init()
  }, [final]);


  React.useEffect(() => {
    if (window.location.href.includes("?ref=")) {

      let getAddress = window.location.href.split("?ref=")[1];
      console.log(getAddress, "getAddress")
      let final = getAddress.slice(0, 42);
      localStorage.setItem("CITY_ADD", final);
    }
  }, []);

  return (
    <>

      <ToastContainer />
      <ThemeProvider theme={theme}>
        <Router history={history}>
          <MainApp ConnectToWallet={connectTotheWallet} useraccount={Useraccount} contract={mincontract} />
        </Router>
      </ThemeProvider>
    </>
  );
}

export default App;




